import type { CorrectComponentType } from "/npm/@brytdesigns/web-component-utils@0.1.7";

import { Show, createMemo } from "/npm/solid-js@^1.9.5/+esm";

import {
  type ValidHybridPath,
  useFullPropertyPath,
  useFormattedValue,
} from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/hooks/index.js";
import { getTemplateContent } from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/utils/index.js";
import html from "/npm/solid-js@^1.9.5/html/+esm";
import HybridCart from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29";

type Status = (typeof HybridCart)["status"];

type CartLoadingStateProps = {
  ignoredStates: Array<Status>;
};

export const CartLoadingState: CorrectComponentType<CartLoadingStateProps> = (
  props,
  { element },
) => {
  const cart = HybridCart;

  const templates = {
    pending: getTemplateContent(element, "pending"),
    error: getTemplateContent(element, "error"),
    success: getTemplateContent(element, "success"),
  };

  let previousState: Status | null = null;

  const cartState = createMemo(() => {
    const state = cart?.status;
    if (!templates[state] || props.ignoredStates.includes(state))
      return previousState;
    previousState = state;
    return state;
  });

  return html`
    <${Show} when=${() => cart}>
      ${() => {
      const state = cartState();
      if (!state) return null;
      if (!templates[state]) return null;
      const children = Array.from(
        templates[state].cloneNode(true).childNodes,
      );
      return children;
    }}
    <//>
  `;
};
